import React, { useState, useEffect } from "react";
import api from "../../Services/api";

const PlanosDescricaoContent = (props: any) => {

    const [page, setLayoutPagina] = useState<any[]>([]);

    useEffect(() => {
        api
            .get("/ObterLayoutPaginaFiltro?Identificador=" + props.page)
            .then((response) => {

                setLayoutPagina(response.data.results);
            })
            .catch((err) => {
                throw new Error(err);
            });
    }, [props.page]);

    function renderObjectBody(data: any) {
        return { __html: data }
    }

    return (
        <div className="row justify-content-center">

            {page?.filter(i => i.Identificador === props.page).map(item => (

                <div className="col-lg-10">

                    <span dangerouslySetInnerHTML={renderObjectBody(item?.Corpo)} />

                </div>

            ))}
        </div>
    )
};
export default PlanosDescricaoContent;
